<div class="overflow-h m-width">
  <!-- <app-loader *ngIf="!!isLoading"></app-loader> -->
  <div class="pad-5 flex align-c justify-space-between border-b border-c">
    <div class="font-16 pad-10">Do you want to request the rate?</div>
    <button class="icon-btn-basic" aria-label="Example icon button with a vertical three dot icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="pad-16 border-b border-c pos-r">
    <div class="flex align-c ">
      <div class="flex flex-d-c overflow-e">
        <div class="head-c overflow-e f-w-500 font-12">{{inputObj?.from?.location_name}}
          ({{inputObj?.from?.location_code}}) - {{inputObj?.from?.country_code}}
        </div>
        <div class="sub-c font-10">{{inputObj?.from?.location_code}} -
          {{inputObj?.from?.country_code}}</div>
      </div>
      <div class="flex align-c justify-c"> <span class="material-symbols-outlined mar-lr-10">arrow_right_alt</span>
      </div>
      <div class="flex flex-d-c mar-l-10 overflow-e">
        <div class="head-c overflow-e f-w-500 font-12">{{inputObj?.to?.location_name}}
          ({{inputObj?.to?.location_code}}) - {{inputObj?.to?.country_code}}
        </div>
        <div class="sub-c font-10">{{inputObj?.to?.location_code}} -
          {{inputObj.to?.country_code}}</div>
      </div>

    </div>
    <div class="flex align-c justify-space-between mar-t-10 ">
      <div class="flex align-c">
        <div class="flex align-c primary-c pad-5 overflow-h border-r-4 fon-12"
          style="background-color: var(--color-primary-opacity-5);width: max-content;height: 25px;">
          <span class="material-symbols-outlined primary-c icon-16 mar-r-10">directions_boat</span>
          {{inputObj?.vessel_name && inputObj?.vessel_name?.value?inputObj?.vessel_name?.value:'FCL'}}
        </div>
        <div class="mar-lr-10 flex align-c">
          <div class="pad-5 flex align-c border-r-4 mar-l-5 font-12 chip-bg" matTooltip="Container type"
            *ngIf="!!inputObj?.containers && !!inputObj?.containers.length" style="height: 25px;">
      {{!!inputObj?.no_of_container?inputObj?.no_of_container:1}} X     {{inputObj?.containers[0]?.container_code +(inputObj?.containers.length>1?'
                  (+'+(inputObj?.containers.length-1)+")":'')}}
          </div>
          <div class="pad-5 flex align-c  border-r-4 mar-l-5 font-12 chip-bg" matTooltip="Shipping liner"
            *ngIf="!!inputObj?.liners && !!inputObj?.liners.length" style="height: 25px;">
            {{inputObj?.liners[0]?.scac_code +(inputObj?.liners.length>1?'
                  +'+(inputObj?.liners.length-1):'')}}
          </div>
          <div class="pad-5 flex align-c border-r-4 mar-l-5 font-12 chip-bg" matTooltip="Cargo ready date"
            style="height: 25px;" *ngIf="!!inputObj?.cargo_ready_date">
            {{inputObj?.cargo_ready_date | date }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pad-16 overflow-a rr-con-height">
    <div class="mar-b-10">Special Instructions (optional)</div>
    <div>
      <textarea class="pad-10 input-c width-100" style="height: 150px;" [(ngModel)]="remarks"></textarea>
    </div>
  </div>
  <div class="pad-10 flex align-c justify-r border-c border-t">
    <button mat-stroked-button class="mar-r-10" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="submitRateRequest(submitRateRequestTemplate)">Request Rate</button>
  </div>

</div>

<ng-template #submitRateRequestTemplate>

  <div class="pad-lr-10 mar-t-10 flex align-c justify-r">
    <button class="icon-btn-basic" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="pad-30 flex align-c flex-d-c mar-b-10">
    <div class="f-w-500 font-20 mar-b-10 text-a-c">Your rate request has been submitted</div>
    <div class="flex align-c justify-c pad-10">
      <img loading="lazy" src="https://app.atmavaan.com/uploads/Tick_svg_2_2023-12-24_21:55:57.svg" height="80px">
    </div>
    <div class="f-w-500 font-16 mar-t-10 text-a-c">Your Rate Request Number: {{rateRequestInfo?.reference_no}}</div>
    <div class=" font-14 mar-t-15 head-c text-a-c">You will be notified, once the rate is ready</div>

    <div class="mar-t-15">
      <button mat-flat-button color="primary" (click)="openRequest()">View Request</button>
    </div>
  </div>
</ng-template>
